import { render, staticRenderFns } from "./YearCard.vue?vue&type=template&id=633b04b3"
import script from "./YearCard.vue?vue&type=script&lang=js"
export * from "./YearCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports